import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { Config } from "@/utils/config.utils";

import { useSearchResultsContext } from "../../context/searchResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showResults, hasResults } = useSearchResultsContext();

    if (!showResults || !hasResults) {
        return null;
    }

    return (
        <article
            className={cn(
                "tw:min-h-[calc(100dvh-var(--spacing-header-height-mobile))]",
                "tw:lg:min-h-[calc(100dvh-var(--spacing-header-height-desktop))]",
                {
                    "tw:min-h-0 tw:lg:min-h-0": Config.general.author
                }
            )}
        >
            {children}
        </article>
    );
};

export { Base };
